import { AppConfig } from 'loot-core/shared/app-config';

export const APP_CONFIG: AppConfig = {
  serverUrl: window['GS_SERVER_URL'],
  newServerUrl: window['GS_NEW_SERVER_URL'],
  googleAnalyticsId: window['GS_GOOGLE_ANALYTICS_ID'],
  posthogApiKey: window['POSTHOG_API_KEY'],
  quilttLinkServer: window['QUILTT_LINK_SERVER'],
  googleClientId: window['GOOGLE_CLIENT_ID'],
};
